import { render } from "./linkipedia.vue?vue&type=template&id=21d04d76&scoped=true"
import script from "./linkipedia.vue?vue&type=script&lang=js"
export * from "./linkipedia.vue?vue&type=script&lang=js"

import "./linkipedia.vue?vue&type=style&index=0&id=21d04d76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d04d76"]])

export default __exports__